import { Api } from '@core/api';
import { links } from '@core/router';
import { injectTSDI } from '@core/tsdi';
import { Skeleton } from '@components/ui/skeleton';
import React from 'react';
import { Link } from 'react-router-dom';
import { UserSearchSupportDto } from '@api/MobileClient';

const cache = new Map<string, UserSearchSupportDto | null>();
const inFlight = new Map<string, Promise<UserSearchSupportDto | null>>();

function loadUser(api: Api, userId: string) {
    const pending = inFlight.get(userId);
    if (pending) {
        return pending;
    }
    const request = api.mobileClient.supportApi
        .userSearchSupportControllerGetUser(Number(userId))
        .then((response) => response.data as UserSearchSupportDto | null)
        .catch(() => null)
        .then((user) => {
            cache.set(userId, user);
            inFlight.delete(userId);
            return user;
        });
    inFlight.set(userId, request);

    return request;
}

export const UserCell = ({ userId }: { userId?: string }) => {
    const api = injectTSDI(Api);
    const [user, setUser] = React.useState<
        UserSearchSupportDto | null | undefined
    >(() => (userId ? cache.get(userId) : null));

    React.useEffect(() => {
        if (!userId) {
            return;
        }
        if (cache.has(userId)) {
            setUser(cache.get(userId));

            return;
        }
        let active = true;
        loadUser(api, userId).then((loaded) => {
            if (active) {
                setUser(loaded);
            }
        });

        return () => {
            active = false;
        };
    }, [userId]);

    if (!userId) {
        return <span className="text-sm">—</span>;
    }

    const name = user && `${user.firstName} ${user.lastName}`.trim();

    return (
        <Link to={links.userDetails(userId)}>
            {user === undefined ? (
                <Skeleton className="h-4 w-[110px]" />
            ) : (
                <span className="text-sm font-semibold">{name || userId}</span>
            )}
        </Link>
    );
};
